import { render, staticRenderFns } from "./PeopleSelect.vue?vue&type=template&id=36fa919a&scoped=true&"
import script from "./PeopleSelect.vue?vue&type=script&lang=js&"
export * from "./PeopleSelect.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSelect.vue?vue&type=style&index=0&id=36fa919a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa919a",
  null
  
)

export default component.exports